import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import { CHAT_GRETTINGS } from 'src/utils/constants';

function ChatTips() {
  const { GUIDELINES } = CHAT_GRETTINGS;
  return (
    <Box sx={{ pt: 3, pl: 8 }}>
      <Stack spacing={2}>
        <Box component="span" gap={1} m={0} display="flex">
          {GUIDELINES.map((guideline, index) => (
            <Box gap={1} display="flex" key={index}>
              <Typography component="span" key={index} variant="body2">
                {guideline[0]}
              </Typography>
              {index < GUIDELINES.length - 1 && (
                <Typography component="span" variant="body2">
                  -
                </Typography>
              )}
            </Box>
          ))}
        </Box>
      </Stack>
    </Box>
  );
}

export default ChatTips;
